module.exports = __webpack_public_path__ + "img/pool.b2714a60.png";